module.exports = __webpack_public_path__ + "static/media/info-hotel.672d0a88.jpg";